<template>
    <div id="feedbackModal" class="modal fade" role="dialog">
      <div class="modal-dialog profile-confirm-poup">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header confirmpopup-bgcolor p-0">
            <div class="add-record-title">
              <div>{{ $t('feedback') }}</div>
              <div @click="closeModal()" class="close-icon cursor-pointer">
                <img src="/static/images/icons/ul_close_icon.svg" class="address-images" />
              </div>
            </div>
          </div>
          <div class="modal-body confirm-body">
            <div class="subscribe-body">{{ $t('feedbackLabel') }}</div>
            <textarea
            type="text"
            class="message-box form-control"
                :placeholder="$t('enterMessage')" v-model="feedbackContent" @input="showError = false;"
            ></textarea>
            <div v-if="showError" class="showError">{{ $t('feedbackError') }}</div>
          <div class="proceed-title pb-23">
            {{ $t('feedbackMessage') }}
          </div>
          <div class="radio-buttons ">
            <div class="pb-26">
              <label>
                <input type="radio" :value="true" v-model="followUp" />

                <span class="market-title">{{ $t('Yes') }}</span>
              </label>
            </div>

            <div class="">
              <label>
                <input type="radio" :value="false" v-model="followUp" />

                <span class="market-title">{{ $t('No') }}</span>
              </label>
            </div>
          </div>
          </div>
          <div class="modal-footer confirmpopup-bgcolor col-xs-12 col-sm-12 d-flex-sm-end">
            <div class="">
              <button type="button" class="btn btn-block cancel-changes" @click="closeModal()">{{ $t('cancel') }}</button>
            </div>
            <div class="">
              <button type="button" class="btn btn-block proceed-changes" :disabled="!feedbackContent || followUp === ''" @click="submitContent()">{{ $t('submit') }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
<script>
import $ from 'jquery';
import EventBus from '../../utils/event-bus';

export default {
  data() {
    return {
      followUp: '',
      feedbackContent: '',
      showError: false,
    };
  },
  methods: {
    closeModal() {
      $('#feedbackModal').modal('hide');
      this.followUp = '';
      this.feedbackContent = '';
      this.showError = false;
    },
    submitContent() {
      if (this.feedbackContent.length > 3000) {
        this.showError = true;
      } else {
        $('#feedbackModal').modal('hide');
        const data = {};
        data.feedback = this.feedbackContent;
        if (this.$i18n.locale === 'Portuguese') data.contact = (this.followUp === true) ? 'sim' : 'não';
        else data.contact = (this.followUp === true) ? 'yes' : 'no';
        EventBus.$emit('submitFeedbackEvent', data);
        this.followUp = '';
        this.feedbackContent = '';
        this.showError = false;
      }
    },
  },
};
</script>
  <style scoped>
  label {
      display: inline-block;
      max-width: 100%;
      margin-bottom: 0px !important;
      /* font-weight: 700; */
  }
  .modal-header {
      background-color: #ffffff !important;
      border-bottom: 1px solid #d3d3d3 !important;
      border-top-right-radius: 6px!important;
      border-top-left-radius: 6px!important;
  }
  .modal-header .close {
      background: unset;
      opacity: 1;
      line-height: unset;
      width: unset;
      border-radius: unset;
      color: unset;
      background-color: #ffffff !important;
  }
  .add-record-title {
      display: flex;
      justify-content: space-between;
      font-weight: 600;
      font-size: 20px;
      line-height: 27px;
      color: #1a1a1a;
      padding: 16px 0px 16px 16px;
  }
  .close-icon {
      padding-right: 18px;
  }
  .proceed-title {
      font-size: 16px;
      line-height: 22px;
      color: #3E3E3E;
      padding: 32px 0 13px 0;
  }
  .modal-body {
      padding: 32px 24px 0px 32px;
  }
  .market-title {
      font-weight: 400;
      font-size: 16px;
      line-height: 26px;
      color: #3e3e3e;
  }
  label>input[type="radio"] {
      display: none;
  }
  label>input[type="radio"]+*::before {
      content: "";
      display: inline-block;
      vertical-align: bottom;
      width: 18px;
      height: 18px;
      margin-right: 11px;
      margin-bottom: 4px;
      border-radius: 50%;
      border-style: solid;
      border-width: 1px;
      border-color: #00518a;
      border: 2px solid #4d4d4d;
  }
  label>input[type="radio"]:checked+*::before {
      background: radial-gradient(#00518a 0%, #00518a 46%, transparent 51%, transparent);
      border-color: #00518a;
      border: 2px solid #00518a;
  }
  .proceed-changes,
  .proceed-changes:hover {
      background-color: #01518a;
      height: 44px;
      color: #ffffff;
      font-size: 18px;
      font-weight: 600;
      border-radius: 3px;
      line-height: 25px;
      float: right;
      cursor: pointer;
      padding: 6px 16px;
      text-transform: capitalize;
  }
  .cancel-changes,
  .cancel-changes:hover {
      background-color: #E6E6E6;
      height: 44px;
      min-width: 90px;
      color: #404040;
      font-size: 18px;
      font-weight: 600;
      border-radius: 3px;
      line-height: 25px;
      float: right;
      cursor: pointer;
      padding: 6px 16px;
      border: 1px solid #E6E6E6;
  }
  .modal-footer {
      background-color: #fafaf9 !important;
      padding-right: 0px;
      border: none !important;
      border-bottom-right-radius: 6px;
      border-bottom-left-radius: 6px;
      padding:16px 0px 16px 0px !important;

  }
  .modal-content {
   border: none;
   border-top-right-radius: 6px!important;
   border-top-left-radius: 6px!important;
   border-bottom-right-radius: 0!important;
   border-bottom-left-radius: 0!important;
  }
  .pb-26 {
   padding-bottom: 26px;
  }
  .radio-buttons {
   padding-bottom: 40px;
  }
  @media (min-width: 768px) {
  .modal-dialog {
   width: 615px;
   margin: 30px auto;
  }
  }
  .subscribe-body {
    font-size: 16px;
    color: #3E3E3E;
    font-weight: 400;
    font-style: normal;
    line-height: 25px;
    padding-bottom: 5px;
  }
  .message-box {
    min-height: 106px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 26px;
    color: #4D4D4D;
    padding-left: 12px;
    padding-top: 12px;
    /* padding-bottom: 6px; */
    background: #FFFFFF;
    border: 1px solid #4D4D4D;
    border-radius: 3px;
    resize: none;
}

.showError {
    color: #a20000;
    font-size: 14px;
}
  </style>
